module.exports = __webpack_public_path__ + "static/media/indifferent.ce5c87cf.png";